require('dotenv').config();
const dBType: any = process.env[`APP_DB_TYPE`] || 'mysql';
export const configs = {
  port: parseInt(process.env[`APP_SERVER_PORT`]) || 6018,
  database: {
    type: dBType,
    host: process.env[`APP_DB_HOST`] || 'Dev.schemaxtech.in',
    port: parseInt(process.env[`APP_DB_PORT`]) || 3306,
    username: process.env[`APP_DB_USER`] || 'sa_dev_user',
    password: process.env[`APP_DB_PASS`] || 'Schemax@23',
    dbName: process.env[`APP_DB_DBNAME`] || 'hospitality_crux',
    poolLimit: parseInt(process.env[`APP_DB_POOL_LIMIT`]) || 20
  }
}

export default configs;
